import { Button, Container, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Stack spacing={2} alignItems="flex-start">
        <Typography variant="h1">Page not found</Typography>
        <Typography color="text.secondary">
          The requested PoolAppy admin page does not exist.
        </Typography>
        <Button component={Link} to="/" variant="contained">
          Return to admin
        </Button>
      </Stack>
    </Container>
  );
}
